import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { OTHER_TYPE } from "@faire/help-center-utils/consts/OTHER_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { IOption } from "@faire/web--source/slate/Dropdown";

export const CUSTOMER_TYPE_PROMPT_MESSAGE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Are you a retailer or brand?",
  });
export const EMAIL_PROMPT_MESSAGE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Contact Email",
    description: { text: "Placeholder for an email form field" },
  });

export const BUSINESS_NAME_PROMPT_MESSAGE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Business name",
    description: {
      text: "Placeholder for a business name form field",
    },
  });
export const TICKET_DETAIL_PROMPT_MESSAGE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Please describe your question in detail",
  });

const RETAILER_TYPE_LABEL = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "I am a retailer",
    description: {
      text: "Option shown in a dropdown asking users to choose the kind of user they are",
    },
  });
const BRAND_TYPE_LABEL = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "I am a brand",
    description: {
      text: "Option shown in a dropdown asking users to choose the kind of user they are",
    },
  });
const OTHER_TYPE_LABEL = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Other",
    description: {
      text: "Option shown in a dropdown asking users to choose the kind of user they are; this option for when they do not identify as a brand nor a retailer",
    },
  });

const CUSTOMER_TYPE_LIST = (
  strictLocalize: StrictLocalizeFunction
): IOption<string>[] => [
  {
    value: RETAILER_TYPE,
    label: RETAILER_TYPE_LABEL(strictLocalize),
  },
  {
    value: BRAND_TYPE,
    label: BRAND_TYPE_LABEL(strictLocalize),
  },
];

const INCLUSIVE_CUSTOMER_TYPE_LIST = (
  strictLocalize: StrictLocalizeFunction
): IOption<string>[] => [
  ...CUSTOMER_TYPE_LIST(strictLocalize),
  {
    value: OTHER_TYPE,
    label: OTHER_TYPE_LABEL(strictLocalize),
  },
];

export const getCustomerTypeList = (
  strictLocalize: StrictLocalizeFunction
): IOption<string>[] => {
  return INCLUSIVE_CUSTOMER_TYPE_LIST(strictLocalize);
};
